module.exports = __webpack_public_path__ + "static/media/silhouette.6a3224bf.svg";